/**
 * Browser-agnostic detector for Brazilian Portuguese (pt-BR)
 * Super lightweight and reusable
 */

export const isBrazilianUser = () => {
  // For debugging only translation in browser
  // console.log('detectBrazil - Starting detection...');
  
  // Check navigator language (primary method)
  if (typeof navigator !== 'undefined' && navigator.language) {
    const lang = navigator.language.toLowerCase();
    // console.log('detectBrazil - navigator.language:', navigator.language, '→', lang);
    if (lang === 'pt-br' || lang.startsWith('pt-br')) {
      // console.log('detectBrazil - Found pt-BR in navigator.language!');
      return true;
    }
  }

  // Check navigator languages array (fallback)
  if (typeof navigator !== 'undefined' && navigator.languages) {
    // console.log('detectBrazil - navigator.languages:', navigator.languages);
    for (const lang of navigator.languages) {
      const lowerLang = lang.toLowerCase();
      if (lowerLang === 'pt-br' || lowerLang.startsWith('pt-br')) {
        // console.log('detectBrazil - Found pt-BR in navigator.languages!');
        return true;
      }
    }
  }

  // Check localStorage for user preference (if explicitly set)
  if (typeof localStorage !== 'undefined') {
    const userLang = localStorage.getItem('userLanguage');
    if (userLang === 'pt-br') {
      return true;
    }
  }

  // Check URL params (useful for testing)
  if (typeof window !== 'undefined' && window.location) {
    const params = new URLSearchParams(window.location.search);
    if (params.get('lang') === 'pt-br') {
      return true;
    }
  }

  // console.log('detectBrazil - No pt-BR detected, returning false');
  return false;
};

// Cache the result for performance
let cachedResult = null;

export const getBrazilianStatus = () => {
  if (cachedResult === null) {
    cachedResult = isBrazilianUser();
  }
  return cachedResult;
};

// Force refresh the cache (useful if user changes language)
export const refreshBrazilianStatus = () => {
  cachedResult = null;
  return getBrazilianStatus();
};

// Utility to set user language preference
export const setUserLanguage = (lang) => {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem('userLanguage', lang);
    refreshBrazilianStatus();
  }
};